import { useCallback, useEffect, useRef, useState } from "react";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import {
  Avatar,
  Button,
  Col,
  message,
  Modal,
  Row,
  Table,
  Input,
  Select,
  Space,
  Tooltip,
  Popover,
  Divider,
  Badge,
  Dropdown,
} from "antd";
import {
  UserOutlined,
  SearchOutlined,
  PlusOutlined,
  LoadingOutlined,
  FullscreenOutlined,
  FilterOutlined,
  UploadOutlined,
  DeleteOutlined,
  DownOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  getAllRequest,
  getFormData,
  getFormStruc,
  getExportData,
  ChangeStatus,
  UploadBulkData,
  UploadBulkUpdate,
  getAllCountries,
  getExcelLink,
  getAcountOwnerList,
  getDirectoryFilterOptions,
  SoftDeleteReq,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import {
  setInitialFormData,
  setFormStructure as setFormStructureView,
  setStep as setStepView,
  resetFormData as resetForm,
} from "../../Redux/ViewFormSlice";

import {
  setFormStructure,
  setStep,
  resetFormData,
} from "../../Redux/formSlice";

import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { ReactComponent as ExcelIcon } from "../../assets/ExcelIcon.svg";
import * as XLSX from "xlsx-js-style";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./MasterDB.css";
import axios from "axios";
import { decryptObject, hasPermission } from "../GlobalFunction";
import { statusChoices, STATUS_OPTIONS } from "../../utils/statusRules";
const { Option } = Select;

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
};

const DEFAULT_FILTERS = {
  employee_full_name: "",
  emp_id: "",
  client_name: "",
  client_ids: [],
  customer_ids: [],
  account_owner: "",
  start_date_of_employment: null,
  country: [],
  status: "",
};

const statusOptions = [
  { label: "All", value: "" },
  { label: "Onboarding", value: "Onboarding" },
  { label: "Awaiting Start Date", value: "Awaiting Start Date" },
  { label: "On Hold", value: "Hold" },
  { label: "Lost", value: "Lost" },
  { label: "Live", value: "Live" },
  { label: "Exit", value: "Exit" },
];

const AllRequest = () => {
  const dispatch = useDispatch();
  const [allRequest, setAllRequest] = useState([]);
  const [total, setTotal] = useState(0);
  const FILTER_STORE_KEY = "masterdb_filters";
  const savedView = (() => {
    try {
      return JSON.parse(sessionStorage.getItem(FILTER_STORE_KEY)) || {};
    } catch {
      return {};
    }
  })();
  const [pagination, setPagination] = useState(
    savedView.pagination || { current: 1, pageSize: 100 }
  );
  const fileInputRef = useRef(null);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [statusModalVisible, setStatusModalVisible] = useState(false);
  const [selectedStatusRecord, setSelectedStatusRecord] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [exitEndDate, setExitEndDate] = useState(null);
  const [reasonOfClosing, setReasonOfClosing] = useState(null);
  const [terminationNotes, setTerminationNotes] = useState("");
  const [countries, setCountries] = useState([]);
  const [isImport, setIsImport] = useState(false);
  const [countryLoader, setCountryLoader] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorDetails, setErrorDetails] = useState([]);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [filterPopoverVisible, setFilterPopoverVisible] = useState(false);
  const sessioninfo = decryptObject(sessionStorage.getItem("sessioninfo"));
  const canCreateDirectory = hasPermission("directory", "create");
  const canDeleteDirectory = hasPermission("directory", "delete");
  const canUpdateDirectory = hasPermission("directory", "update");
  // "Deactivate" (soft-delete) is strictly Admin-only, confirmed with the
  // user, 2026-10-27 -- independent of directory:delete, which could in
  // principle be granted to another role via the Roles page. userType's
  // stored type is inconsistent across the app (sometimes a string,
  // sometimes a number), so compare numerically, same as elsewhere.
  const isAdmin = Number(sessioninfo?.userType) === 1;
  const updateFileInputRef = useRef(null);
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const [updateErrors, setUpdateErrors] = useState([]);
  const [updateErrorMessage, setUpdateErrorMessage] = useState("");
  const [updateErrorModalVisible, setUpdateErrorModalVisible] = useState(false);
  // Admin only: when the rows were rejected only for missing mandatory fields the server says
  // requires_confirmation; the same error list is shown plus "Continue anyway", which sends the same
  // file again with confirm_missing so it is saved as it is.
  const [pendingBulkFile, setPendingBulkFile] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  const [searchFilters, setSearchFilters] = useState({
    ...DEFAULT_FILTERS,
    ...(savedView.filters || {}),
  });
  // Options for Client / Customer / Country / Status, loaded from the data itself
  const [filterOptions, setFilterOptions] = useState({
    clients: [],
    customers: [],
    countries: [],
    statuses: [],
  });

  // Keep filters/page until the user clears them (survives opening a record and coming back)
  useEffect(() => {
    try {
      sessionStorage.setItem(
        FILTER_STORE_KEY,
        JSON.stringify({ filters: searchFilters, pagination })
      );
    } catch {}
  }, [searchFilters, pagination]);
  const [accountOwnerOptions, setAccountOwnerOptions] = useState([]);

  const navigate = useNavigate();

  const filterDebounceRef = useRef(null);

  useEffect(() => {
    return () => clearTimeout(filterDebounceRef.current);
  }, []);

  const generateColumnsFromData = (ColumnList) => {
    const keys = ColumnList.filter(
      (key) =>
        key !== "assign_to" &&
        key !== "id" &&
        key !== "onboardId" &&
        key !== "organization_id" &&
        key !== "employee_full_name" &&
        key !== "Employee_Name" &&
        key !== "Employee_First_Name" &&
        key !== "Employee_Middle_Name" &&
        key !== "Employee_Last_Name" &&
        key !== "Remarks" &&
        key !== "Employee_Status"
    );

    const dynamicColumns = keys.map((key) => ({
      title: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      dataIndex: key,
      key: key,
      ellipsis: true,
      render: (text) => (
        <div style={{ minWidth: 100, whiteSpace: "nowrap" }}>
          {text && text !== "null" ? text : ""}
        </div>
      ),
    }));

    dynamicColumns.push({
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      fixed: "right",
      render: (text, record) => {
        // Only the statuses that make sense for this person's dates (see utils/statusRules.js);
        // the current status stays in the list (disabled) so the box still shows it.
        const current = record["Employee_Status"];
        const { options: allowed, note } = statusChoices({
          status: current,
          startDate: record["Start_date_of_Employment"],
          endDate: record["End_date_of_Employment"],
        });
        const currentOption = STATUS_OPTIONS.find((o) => o.value === current) || {
          label: current,
          value: current,
        };
        const select = (
        <Select
          style={{
            width: 120,
            borderRadius: "8px",
            fontSize: "0.8rem",
          }}
          dropdownStyle={{
            borderRadius: "8px",
          }}
          value={record["Employee_Status"]}
          onChange={(value) => {
            setSelectedStatusRecord(record);
            setNewStatus(value);
            if (value === "Exit") {
              // Pre-fill the end date / reason already saved for this employee
              const savedEnd = record["End_date_of_Employment"];
              const m = /^(\d{1,2})-([A-Za-z]{3})-(\d{2,4})$/.exec(savedEnd || "");
              if (m) {
                const months = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                const yr = m[3].length === 2 ? 2000 + Number(m[3]) : Number(m[3]);
                setExitEndDate(new Date(yr, months.indexOf(m[2].toLowerCase()), Number(m[1])));
              }
              if (record["Reason_for_closing"]) {
                setReasonOfClosing(record["Reason_for_closing"]);
              }
            }
            setStatusModalVisible(true);
          }}
        >
          {[{ ...currentOption, disabled: true }, ...allowed].map((item) => (
            <Option key={item.value} value={item.value} disabled={item.disabled}>
              {item.label}
            </Option>
          ))}
        </Select>
        );
        return note ? <Tooltip title={note}>{select}</Tooltip> : select;
      },
    });

    dynamicColumns.unshift({
      title: "Employee Name",
      fixed: "left",
      key: "employee_full_name",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            gap: "0.1rem",
            alignItems: "center",
          }}
        >
          <Avatar size={20} icon={<UserOutlined />} />
          <Button
            type="link"
            onClick={() => handleView(record)}
            style={{ fontSize: "0.8rem" }}
          >
            {record["Employee_Name"] || "N/A"}
          </Button>
        </div>
      ),
      responsive: ["xs", "sm", "sm"],
    });

    return dynamicColumns;
  };

  const handleNew = async () => {
    try {
      setLoading(true);
      const res = await getFormStruc({
        country: "india",
      });
      if (res.responseCode === 200) {
        dispatch(setFormStructure(res.data));
        dispatch(setStep(1));
        navigate("/onboardForm");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (page = 1, pageSize = 100, filters = {}) => {
    setLoading(true);
    try {
      let requestRes = await getAllRequest(page, pageSize, null, filters);
      if (typeof requestRes === "string") {
        requestRes = requestRes.replace(/\bNaN\b/g, "null");
        requestRes = JSON.parse(requestRes);
      }
      if (requestRes?.responseCode === 200) {
        setTotal(requestRes?.total_records || 0);
        const Response = requestRes?.onboard_forms;
        setAllRequest(Response);
        if (Response.length > 0) {
          const dynamicCols = generateColumnsFromData(requestRes?.column_keys);
          setColumns(dynamicCols);
        } else {
          setColumns([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchData = useCallback(
    debounce((page, pageSize, filters) => {
      fetchData(page, pageSize, filters);
    }, 500),
    []
  );

  const handleFilterChange = (filterName, value) => {
    const processedValue =
      filterName === "start_date_of_employment" && value
        ? dayjs(value).format("YYYY-MM-DD")
        : value ?? "";

    const nextFilters = {
      ...searchFilters,
      [filterName]: processedValue,
    };

    // Customers depend on the selected clients: keep only the ones that still belong
    if (filterName === "client_ids") {
      const keep = new Set(
        filterOptions.customers
          .filter((c) => (processedValue || []).includes(c.client_id))
          .map((c) => c.value)
      );
      nextFilters.customer_ids = (searchFilters.customer_ids || []).filter((id) =>
        keep.has(id)
      );
    }

    setSearchFilters(nextFilters);
    setPagination((prev) => ({ ...prev, current: 1 }));

    clearTimeout(filterDebounceRef.current);

    const loadFilteredData = () =>
      fetchData(1, pagination.pageSize, nextFilters);

    const textFilters = ["employee_full_name", "emp_id", "client_name"];

    if (textFilters.includes(filterName)) {
      filterDebounceRef.current = setTimeout(loadFilteredData, 400);
    } else {
      loadFilteredData();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImportModalVisible(false);
    const formData = new FormData();
    formData.append("file", file);
    setIsImport(true);
    try {
      let response = await UploadBulkData(formData, true);

      if (typeof response === "string") {
        response = response.replace(/\bNaN\b/g, "null");
        response = JSON.parse(response);
      }

      if (response.responseCode === 200) {
        message.success("File uploaded successfully!");
        fetchData(pagination.current, pagination.pageSize, searchFilters);
      } else {
        message.error(response.responseMessage || "Upload failed!");
        if (response.error_data) {
          setErrorDetails(response.error_data);
          setErrorModalVisible(true);
        }
      }
    } catch (error) {
      message.error("Something went wrong!");
      console.error("Error parsing or uploading:", error);
    } finally {
      setIsImport(false);
      event.target.value = null;
    }
  };

  const clearFilters = () => {
    const clearedFilters = { ...DEFAULT_FILTERS };
    setSearchFilters(clearedFilters);
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchData(1, pagination.pageSize, clearedFilters);
  };

  const handleTableChange = (paginationInfo) => {
    const newPagination = {
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    };
    setPagination(newPagination);
    fetchData(paginationInfo.current, paginationInfo.pageSize, searchFilters);
  };

  useEffect(() => {
    dispatch(resetFormData({}));
    dispatch(resetForm({}));
  }, []);

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize, searchFilters);
    fetchCountry();
  }, []);

  useEffect(() => {
    const fetchAccountOwners = async () => {
      try {
        const res = await getAcountOwnerList();
        if (res?.responseCode === 200) {
          const options = (res?.res || []).map((owner) => ({
            label: owner.name,
            value: owner.name,
          }));
          setAccountOwnerOptions(options);
        }
      } catch (error) {
        console.error("Failed to fetch account owners:", error);
      }
    };
    fetchAccountOwners();
  }, []);

  // Client / Customer / Country / Status options. Re-fetched whenever the selected
  // clients or customers change, so Customer and Country only offer valid choices.
  const clientKey = (searchFilters.client_ids || []).join(",");
  const customerKey = (searchFilters.customer_ids || []).join(",");
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getDirectoryFilterOptions(
          searchFilters.client_ids || [],
          searchFilters.customer_ids || []
        );
        if (cancelled || res?.responseCode !== 200) return;
        setFilterOptions({
          clients: res.clients || [],
          customers: res.customers || [],
          countries: res.countries || [],
          statuses: res.statuses || [],
        });

        // A country picked earlier may not exist for the new client/customer: drop it
        const available = new Set(res.countries || []);
        const selected = searchFilters.country || [];
        const stillValid = selected.filter((c) => available.has(c));
        if (stillValid.length !== selected.length) {
          const next = { ...searchFilters, country: stillValid };
          setSearchFilters(next);
          setPagination((prev) => ({ ...prev, current: 1 }));
          fetchData(1, pagination.pageSize, next);
        }
      } catch (error) {
        console.error("Failed to fetch filter options:", error);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientKey, customerKey]);

  const fetchCountry = async () => {
    try {
      setCountryLoader(true);

      const response = await getAllCountries(1);
      const rawObjects = response?.country_list ?? [];

      const CountryList = rawObjects
        .sort((a, b) => (a.country_name || "").localeCompare(b.country_name || ""))
        .map((item) => {
          const fullString = item.country_name || "";
          const cleanName = fullString.split("(")[0].trim();

          return {
            label: fullString,
            value: cleanName,
          };
        });

      setCountries(CountryList);
    } catch (error) {
      console.error("Fetch error details:", error);
      message.error("Error in fetching Country Data");
    } finally {
      setCountryLoader(false);
    }
  };

  const handleView = async (record) => {
    try {
      setLoading(true);

      const [formStructureRes, formDataRes, ownersRes] =
        await Promise.allSettled([
          getFormStruc({ country: "india" }),
          getFormData(record?.onboardId),
          getAcountOwnerList(),
        ]);

      let updatedStructure = null;

      if (
        formStructureRes.status === "fulfilled" &&
        formStructureRes.value?.responseCode === 200
      ) {
        updatedStructure = structuredClone(formStructureRes.value.data);
      } else {
        message.error("Failed to load form structure");
        return;
      }

      if (
        ownersRes.status === "fulfilled" &&
        ownersRes.value?.responseCode === 200
      ) {
        const formattedOptions = (ownersRes.value.res || []).map((owner) => ({
          label: owner.name,
          value: owner.id,
        }));

        Object.values(updatedStructure).forEach((steps) =>
          steps.forEach((section) =>
            Object.values(section).forEach((fields) =>
              fields.forEach((field) => {
                if (field.id === 96) {
                  field.option = formattedOptions;
                }
              })
            )
          )
        );
      }

      if (
        formDataRes.status !== "fulfilled" ||
        formDataRes.value?.responseCode !== 200
      ) {
        message.error("Failed to load form data");
        return;
      }

      const parsedFormData = { ...formDataRes.value.data };

      if (parsedFormData?.[89]) {
        parsedFormData[89] = Number(parsedFormData[89]);
      }

      const isFixedType = parsedFormData?.[50]?.toLowerCase() === "fixed";

      Object.values(updatedStructure).forEach((steps) =>
        steps.forEach((section) =>
          Object.values(section).forEach((fields) =>
            fields.forEach((field) => {
              if (field.id === 53) {
                field.required = isFixedType;
              }
            })
          )
        )
      );

      dispatch(setFormStructureView(updatedStructure));
      dispatch(setInitialFormData(parsedFormData));
      dispatch(setStepView(1));

      sessionStorage.setItem("onboard_id", record?.onboardId);
      navigate("/reviewForm");
    } catch (error) {
      console.error("Error in handleView:", error);
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      let requestRes = await getAllRequest(1, 1000, null, searchFilters, true);

      if (typeof requestRes === "string") {
        requestRes = requestRes.replace(/\bNaN\b/g, "null");
        requestRes = JSON.parse(requestRes);
      }

      if (requestRes?.responseCode === 200) {
        const Response = requestRes?.onboard_forms;
        if (Array.isArray(Response)) {
          const cleanData = Response.map((row) =>
            Object.fromEntries(
              Object.entries(row).map(([key, value]) => [key, value ?? ""])
            )
          );

          const headers = requestRes?.column_keys;

          const worksheet = XLSX.utils.json_to_sheet(cleanData, {
            header: headers,
          });

          const columnWidths = headers.map((header) => {
            const maxContentLength = Math.max(
              header.length,
              ...cleanData.map((row) =>
                row[header] ? String(row[header]).length : 0
              )
            );
            return { wch: maxContentLength + 2 };
          });
          worksheet["!cols"] = columnWidths;

          headers.forEach((header, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            worksheet[cellRef] = worksheet[cellRef] || { t: "s", v: header };
            worksheet[cellRef].s = {
              font: {
                bold: true,
                color: { rgb: "FFFFFF" },
              },
              fill: {
                fgColor: { rgb: "4F81BD" },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
            };
          });

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Employee_Directory_Sheet"
          );

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(fileData, "Employee_Directory_Sheet.xlsx");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (newStatus === "Exit" && !exitEndDate) {
      message.error("Please select the End Date of Employment");
      return;
    }

    try {
      setUpdateLoader(true);
      const body = {
        onboard_id: selectedStatusRecord?.onboardId,
        status: newStatus,
      };

      if (newStatus === "Exit") {
        body["29"] = dayjs(exitEndDate).format("YYYY-MM-DD");
        body["72"] = reasonOfClosing || "";
        body["73"] = terminationNotes || "";
      }

      const res = await ChangeStatus(body);

      if (res.responseCode === 200) {
        message.success("Status updated successfully");
        fetchData(pagination.current, pagination.pageSize, searchFilters);
      } else {
        message.error(res.message || "Failed to update status");
      }
    } catch (err) {
      message.error("Error updating status");
    } finally {
      setStatusModalVisible(false);
      setSelectedStatusRecord(null);
      setNewStatus(null);
      setExitEndDate(null);
      setReasonOfClosing(null);
      setTerminationNotes("");
      setUpdateLoader(false);
    }
  };

  // Downloads the currently filtered records as an update sheet (same filters as
  // "Download Excel", plus a locked Onboard_Form_ID column) built by the backend.
  const handleDownloadForUpdate = async () => {
    setLoading(true);
    try {
      let listRes = await getAllRequest(
        1,
        1000,
        null,
        { ...searchFilters, for_update: "true" },
        true
      );
      if (typeof listRes === "string") {
        listRes = JSON.parse(listRes.replace(/\bNaN\b/g, "null"));
      }
      const ids = (listRes?.onboard_forms || [])
        .map((row) => row.onboardId)
        .filter(Boolean);
      if (ids.length === 0) {
        message.warning("No records to download for the current filters.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/bulk_update_template`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${sessioninfo?.accessToken}`,
            empId: sessioninfo?.employee_id,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ onboard_ids: ids }),
        }
      );
      if (!response.ok) {
        let errMsg = "Failed to download the update sheet.";
        try {
          errMsg = (await response.json())?.responseMessage || errMsg;
        } catch (e) {}
        message.error(errMsg);
        return;
      }
      saveAs(await response.blob(), "Employee_Bulk_Update_Template.xlsx");
    } catch (error) {
      console.error("Error downloading update sheet:", error);
      message.error("Failed to download the update sheet.");
    } finally {
      setLoading(false);
    }
  };

  const submitBulkUpdate = async (file, confirmMissing = false) => {
    const formData = new FormData();
    formData.append("file", file);
    if (confirmMissing) formData.append("confirm_missing", "true");
    setIsBulkUpdating(true);
    try {
      const res = await UploadBulkUpdate(formData);
      if (res?.responseCode === 200) {
        setUpdateErrorModalVisible(false);
        setPendingBulkFile(null);
        message.success(
          `Bulk update done: ${res.updated} updated, ${res.unchanged} unchanged.` +
            (res.saved_with_missing > 0
              ? ` ${res.saved_with_missing} saved with missing mandatory fields.`
              : "")
        );
        fetchData(pagination.current, pagination.pageSize, searchFilters);
      } else if (Array.isArray(res?.errors) && res.errors.length > 0) {
        setPendingBulkFile(res.requires_confirmation ? file : null);
        setUpdateErrorMessage(res.responseMessage || "");
        setUpdateErrors(res.errors);
        setUpdateErrorModalVisible(true);
      } else {
        message.error(res?.responseMessage || "Bulk update failed.");
      }
    } catch (error) {
      console.error("Error in bulk update:", error);
      message.error("Something went wrong!");
    } finally {
      setIsBulkUpdating(false);
    }
  };

  const handleBulkUpdateFile = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    await submitBulkUpdate(file);
    event.target.value = null;
  };

  const handleExcelDown = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/send-import-link`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${sessioninfo?.accessToken}`,
            empId: sessioninfo?.employee_id,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Sample_Excel.xlsx";
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  // Soft-delete, Admin-only (confirmed with the user, 2026-10-27) --
  // reversible flag flip, not a permanent delete. For cleaning up
  // duplicate records without risking real data loss.
  const handleBulkDeactivate = async () => {
    Modal.confirm({
      title: "Confirm Deactivate",
      content: `Are you sure you want to deactivate ${selectedRowKeys.length} selected record(s)? They'll be hidden from the Directory but not permanently deleted.`,
      okText: "Yes, Deactivate",
      cancelText: "Cancel",
      centered: true,
      onOk: async () => {
        try {
          setIsDeleting(true);
          const res = await SoftDeleteReq({ onboard_id: selectedRowKeys });
          if (res?.responseCode === 200) {
            message.success("Selected records deactivated successfully");
            setSelectedRowKeys([]);
            fetchData(pagination.current, pagination.pageSize, searchFilters);
          } else {
            message.error(res?.responseMessage || "Failed to deactivate records");
          }
        } catch (error) {
          console.error(error);
          message.error("Something went wrong while deactivating");
        } finally {
          setIsDeleting(false);
        }
      },
    });
  };

  const rowSelection =
    canDeleteDirectory
      ? {
          selectedRowKeys,
          onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
          getCheckboxProps: (record) => ({
            disabled: false,
          }),
        }
      : null;

  return (
    <>
      <div className="main-box">
        <Sidebar activeId={3} />

        <main className="main-content">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              minHeight: 0,
            }}
          >
            <Header title="Employee Directory" />

            <div
              style={{
                flex: 1,
                minHeight: 0,
                padding: "1rem",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Spin
                spinning={loading || countryLoader || updateLoader}
                size="large"
                tip="Loading..."
                style={{ display: "block", height: "100%" }}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <input
                  ref={updateFileInputRef}
                  type="file"
                  accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style={{ display: "none" }}
                  onChange={handleBulkUpdateFile}
                />

                {/* Main Filter & Action Control Container */}
                <div className="directory-toolbar">
                  <div className="filter-area">
                    
                    {/* Row 1: All 6 Filter Inputs in One Line */}
                    <div className="filter-row-top">
                      <Input
                        placeholder="Employee Name"
                        prefix={<SearchOutlined />}
                        value={searchFilters.employee_full_name}
                        onChange={(e) =>
                          handleFilterChange("employee_full_name", e.target.value)
                        }
                        allowClear
                      />

                      <Input
                        placeholder="Emp Id"
                        prefix={<SearchOutlined />}
                        value={searchFilters.emp_id}
                        onChange={(e) => handleFilterChange("emp_id", e.target.value)}
                        allowClear
                      />

                      <Select
                        mode="multiple"
                        placeholder="Client"
                        value={searchFilters.client_ids?.length ? searchFilters.client_ids : undefined}
                        onChange={(value) => handleFilterChange("client_ids", value)}
                        options={filterOptions.clients}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount="responsive"
                      />

                      <Select
                        mode="multiple"
                        placeholder="Customer"
                        disabled={!searchFilters.client_ids?.length}
                        value={searchFilters.customer_ids?.length ? searchFilters.customer_ids : undefined}
                        onChange={(value) => handleFilterChange("customer_ids", value)}
                        options={filterOptions.customers}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount="responsive"
                      />

                      <Select
                        placeholder="Account Owner"
                        value={searchFilters.account_owner || undefined}
                        onChange={(value) => handleFilterChange("account_owner", value)}
                        options={accountOwnerOptions}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                      />

                      <DatePicker
                        placeholderText="Employment Date"
                        selected={
                          searchFilters.start_date_of_employment
                            ? new Date(searchFilters.start_date_of_employment)
                            : null
                        }
                        onChange={(date) =>
                          handleFilterChange("start_date_of_employment", date)
                        }
                        className="search-datepicker"
                        isClearable
                        dateFormat="yyyy-MM-dd"
                      />

                      <Select
                        placeholder="Status"
                        value={searchFilters.status || undefined}
                        onChange={(value) => handleFilterChange("status", value)}
                        options={
                          filterOptions.statuses.length
                            ? filterOptions.statuses.map((s) => ({ label: s, value: s }))
                            : statusOptions.filter((o) => o.value)
                        }
                        allowClear
                      />

                      <Select
                        mode="multiple"
                        placeholder="Country"
                        value={searchFilters.country?.length ? searchFilters.country : undefined}
                        onChange={(value) => handleFilterChange("country", value)}
                        options={
                          filterOptions.countries.length
                            ? filterOptions.countries.map((c) => ({ label: c, value: c }))
                            : countries
                        }
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount="responsive"
                      />
                    </div>

                    {/* Row 2: Clear Filters + Actions */}
                    <div className="filter-row-bottom">
                      <Button
                        className="clear-filters-btn"
                        danger
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </Button>

                      <div
                        style={{
                          width: "1px",
                          height: "20px",
                          backgroundColor: "#d9d9d9",
                          margin: "0 4px",
                        }}
                      />

                      {canCreateDirectory && (
                        <Tooltip title="Add New Employee">
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<PlusOutlined />}
                            onClick={handleNew}
                            className="compact-action-btn new-action-btn"
                          />
                        </Tooltip>
                      )}

                      {canCreateDirectory && (
                        <Tooltip title="Import Excel">
                          <Button
                            shape="circle"
                            disabled={isImport}
                            onClick={() => setImportModalVisible(true)}
                            icon={isImport ? <LoadingOutlined /> : <UploadOutlined />}
                            className="compact-action-btn"
                          />
                        </Tooltip>
                      )}

                      <Tooltip title="Download Excel">
                        <Button
                          shape="circle"
                          onClick={handleDownload}
                          icon={<ExcelIcon width={13} height={13} />}
                          className="compact-action-btn download-action-btn"
                        />
                      </Tooltip>

                      {canUpdateDirectory && (
                        <Dropdown
                          trigger={["click"]}
                          menu={{
                            items: [
                              {
                                key: "download-update",
                                icon: <DownloadOutlined />,
                                label: "Download for Update",
                                onClick: handleDownloadForUpdate,
                              },
                              {
                                key: "upload-update",
                                icon: <UploadOutlined />,
                                label: "Upload Updated Sheet",
                                disabled: isBulkUpdating,
                                onClick: () => updateFileInputRef.current?.click(),
                              },
                            ],
                          }}
                        >
                          <Tooltip title="Bulk Update">
                            <Button
                              shape="circle"
                              disabled={isBulkUpdating}
                              icon={isBulkUpdating ? <LoadingOutlined /> : <DownOutlined />}
                              className="compact-action-btn"
                            />
                          </Tooltip>
                        </Dropdown>
                      )}

                      {canDeleteDirectory && isAdmin && (
                        <Tooltip
                          title={
                            selectedRowKeys.length > 0
                              ? `Deactivate Selected (${selectedRowKeys.length})`
                              : "Deactivate Selected"
                          }
                        >
                          <Badge
                            count={selectedRowKeys.length}
                            overflowCount={99}
                            offset={[-2, 2]}
                          >
                            <Button
                              danger
                              shape="circle"
                              icon={
                                isDeleting ? <LoadingOutlined /> : <DeleteOutlined />
                              }
                              disabled={selectedRowKeys.length === 0 || isDeleting}
                              onClick={handleBulkDeactivate}
                              className="compact-action-btn"
                            />
                          </Badge>
                        </Tooltip>
                      )}
                    </div>

                  </div>
                </div>

                <Table
                  columns={columns}
                  dataSource={allRequest}
                  rowSelection={canDeleteDirectory && isAdmin ? rowSelection : null}
                  rowKey="onboardId"
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} records`,
                  }}
                  onChange={handleTableChange}
                  scroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
                  style={{
                    fontSize: "0.7rem",
                    borderRadius: "1.5rem",
                    background: "#FFF",
                    flex: 1,
                  }}
                  className="masterTb custom-scrollbar"
                />
              </Spin>
            </div>
          </div>
        </main>
      </div>

      <Modal
        title="Confirm Status Change"
        open={statusModalVisible}
        onOk={handleConfirm}
        onCancel={() => {
          setStatusModalVisible(false);
          setNewStatus(null);
          setSelectedStatusRecord(null);
          setExitEndDate(null);
          setReasonOfClosing(null);
          setTerminationNotes("");
        }}
        okText="Yes, Change"
        cancelText="Cancel"
        okButtonProps={{
          disabled: newStatus === "Exit" && !exitEndDate,
        }}
        centered
      >
        <p>
          Are you sure you want to change the status to{" "}
          <strong>{newStatus}</strong>?
        </p>

        {newStatus === "Exit" && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              marginTop: "12px",
            }}
          >
            <div>
              <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                End Date of Employment <span style={{ color: "red" }}>*</span>
              </label>
              <DatePicker
                selected={exitEndDate}
                onChange={(date) => setExitEndDate(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select end date"
                className="exit-date-input"
                wrapperClassName="exit-date-wrapper"
                isClearable
              />
            </div>

            <div>
              <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                Reason of Closing
              </label>
              <Select
                placeholder="Select reason"
                value={reasonOfClosing || undefined}
                onChange={(value) => setReasonOfClosing(value)}
                allowClear
                style={{ width: "100%" }}
                options={[
                  { label: "Resignation", value: "Resignation" },
                  { label: "Redundancy", value: "Redundancy" },
                  { label: "Poor Performance", value: "Poor Performance" },
                  { label: "Transfer of Employment", value: "Transfer of Employment" },
                  { label: "Restructuring", value: "Restructuring" },
                  { label: "Fixed Term Contract End", value: "Fixed Term Contract End" },
                ]}
              />
            </div>

            <div>
              <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>
                Termination Notes
              </label>
              <Input.TextArea
                rows={3}
                placeholder="Add any termination notes"
                value={terminationNotes}
                onChange={(e) => setTerminationNotes(e.target.value)}
              />
            </div>
          </div>
        )}
      </Modal>

      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: "40px",
            }}
          >
            <span>Import Excel</span>
            <Button
              type="primary"
              size="small"
              onClick={handleExcelDown}
              style={{ fontSize: "0.75rem" }}
            >
              Sample Excel
            </Button>
          </div>
        }
        open={importModalVisible}
        onCancel={() => setImportModalVisible(false)}
        footer={null}
        centered
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "24px 0",
          }}
        >
          <Button
            type="dashed"
            disabled={isImport}
            onClick={() => fileInputRef.current?.click()}
            icon={isImport ? <LoadingOutlined /> : <UploadOutlined />}
          >
            {isImport ? "Uploading..." : "Browse files from this device"}
          </Button>
        </div>
      </Modal>

      <Modal
        title="Bulk Update Errors"
        open={updateErrorModalVisible}
        onCancel={() => {
          setUpdateErrorModalVisible(false);
          setPendingBulkFile(null);
        }}
        footer={
          pendingBulkFile
            ? [
                <Button
                  key="close"
                  onClick={() => {
                    setUpdateErrorModalVisible(false);
                    setPendingBulkFile(null);
                  }}
                >
                  Close
                </Button>,
                <Button
                  key="continue"
                  type="primary"
                  danger
                  loading={isBulkUpdating}
                  onClick={() => submitBulkUpdate(pendingBulkFile, true)}
                >
                  Continue anyway
                </Button>,
              ]
            : null
        }
      >
        {updateErrorMessage && <p>{updateErrorMessage}</p>}
        <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "8px" }}>
          {updateErrors.map((err, index) => (
            <div key={index} style={{ marginBottom: 10 }}>
              <strong>
                Row {err.row}
                {err.onboard_form_id ? ` (${err.onboard_form_id})` : ""}:
              </strong>{" "}
              {err.message}
            </div>
          ))}
        </div>
      </Modal>

      <Modal
        title="Upload Validation Errors"
        open={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
        footer={null}
      >
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            paddingRight: "8px",
          }}
        >
          {errorDetails.length > 0 ? (
            errorDetails.map((err, index) => (
              <div key={index} style={{ marginBottom: 12 }}>
                <strong>Row {err.row_number + 2}:</strong>

                <div style={{ marginLeft: 16, marginTop: 4 }}>
                  {err.missing_fields.map((field, idx) => (
                    <span
                      key={idx}
                      style={{
                        display: "inline-block",
                        marginRight: 8,
                        whiteSpace: "nowrap",
                      }}
                    >
                      • {field}
                    </span>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p>No detailed error info available.</p>
          )}
        </div>
      </Modal>
    </>
  );
};

export default AllRequest;